import React from 'react';

export default function BookingStepper({ status }) {
    const steps = [
        { id: 'pending', label: 'Requested' },
        { id: 'payment', label: 'Confirmed' },
        { id: 'delivered', label: 'Delivered' },
        { id: 'returned', label: 'Complete' }
    ];

    if (['cancelled', 'declined'].includes(status)) {
        return (
            <div className="bg-red-50 p-4 rounded-xl border border-red-200 flex items-center justify-center gap-2 text-red-700 font-bold w-full">
                <span>❌</span> Booking {status.charAt(0).toUpperCase() + status.slice(1)}
            </div>
        );
    }

    let currentStepIndex = 0;
    if (['awaitingPayment', 'deposit-paid', 'awaitingFinalPayment', 'paid', 'booked'].includes(status)) currentStepIndex = 1;
    if (['delivered', 'awaitingPickup', 'awaitingPlannerConfirmation'].includes(status)) currentStepIndex = 2;
    if (['returned', 'completed'].includes(status)) currentStepIndex = 3;

    return (
        <div className="w-full relative pt-2 pb-6">
            <div className="absolute top-5 left-[12.5%] right-[12.5%] h-1 bg-gray-200 z-0 rounded-full -translate-y-1/2"></div>
            <div className="absolute top-5 left-[12.5%] h-1 bg-green-500 z-0 rounded-full -translate-y-1/2 transition-all duration-500" style={{ width: `${(currentStepIndex / (steps.length - 1)) * 75}%` }}></div>
            
            <div className="flex items-center justify-between w-full relative z-10 px-2 sm:px-4">
                {steps.map((step, idx) => {
                    const isCompleted = idx <= currentStepIndex;
                    const isActive = idx === currentStepIndex;
                    return (
                        <div key={step.id} className="flex flex-col items-center w-1/4">
                            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold shadow-sm transition-colors duration-300 ring-4 ring-white ${isCompleted ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-500'}`}>
                                {isCompleted ? '✓' : idx + 1}
                            </div>
                            <span className={`mt-2 text-[9px] sm:text-[10px] font-bold uppercase tracking-wider whitespace-nowrap text-center ${isActive ? 'text-gray-900' : isCompleted ? 'text-green-600' : 'text-gray-400'}`}>
                                {step.label}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}